module.exports = __webpack_public_path__ + "static/media/lock.755d9820.svg";